<template>
  <div
    :id="`${name}_card-wrapper`"
    class="c-radio-group-field"
    :question-id="`question_${questionNum}`"
    :class="[wrapperStyle.class, fieldValue !== '' ? 'checked-true' : '']"
    :style="[wrapperStyle.style]"
  >
    <div
      class="card"
      :class="[cardStyle.class, cardDefaults]"
      :style="[cardStyle.style]"
    >
      <div class="card-content col s12">
        <div class="col s12">
          <div class="card-title" v-if="titleText">
            <div class="title-text" style="width:100%">{{ titleText }}
    <a href="#" 
        v-if="helperVideo" v-tipped 
        :data-tooltip="helperVideo.tooltip"
        :helper-id="helperVideo.helperId"
        data-position="left"
          class="btn-floating btn-small red waves-effect right">
          <i class="material-icons white-text">
            play_arrow
          </i>
        </a>
            </div>
          </div>
           <div class="label-text">
          <div class="question-number" v-if="showQuestionNum">{{ questionNum + "." }}</div>
          <div class="question-text" v-html="label"></div>
        </div>

          <div class="descriptive-text" v-if="description">
            <span v-html="description"></span>
          </div>
        </div>
        <div class="center-align col s12" v-if="expandList" style="margin: 24px 0; !important">
          <button
            class="btn indigo accent-5  btn-rounded z-depth-0 waves-effect" style="width: 100%;"
            @click.prevent="showList = !showList">
            Click here to see definitions
          </button>
        </div>
          <div class="clear"></div>
        <ExpandTray isList data-classes="in-list" :close-button="true" @tipAction="showList = !showList" :data-list="expandList" v-if="showList" />

        <div class="btn-guide-wrapper" v-if="guideButtonText">
          <button
            class="btn btn-rounded waves-effect btn-guide"
            :class="[guideButtonStyle.class]"
            :style="[guideButtonStyle.style]"
          >
            {{ guideButtonText }}
          </button>
        </div>
        <div class="row" style="margin-bottom:0px;">
          <div
            :class="[$_getGrid(), { 'center-align': imageStyle }]"
            v-for="(opt, index) in options"
            :key="index"
          >
            <div
              class="opt-info-wrapper shadow-depth"
              v-if="imageStyle"
              @click="$_updateValue(opt)"
            >
              <div class="img-wrapper">
                <img :src="$_getImg(opt.localImage)" alt="" srcset="" />
              </div>
              <p class="text-label">
                {{ opt.text }}
              </p>
            </div>
            <div
              class="radio-option z-depth-1"
              :class="[
                { 'card-style': !imageStyle },
                { 'active': opt.value === fieldValue && !imageStyle },
                {'disabled': !viewConditions}
              ]"
              @click="$_updateValue(opt)"
            >
              <label>
                <input
                  type="radio"
                  class="with-gap"
                  :value="opt.value"
                  v-model="fieldValue"
                  :disabled="!viewConditions || isDisabled"
                  @change="$_updateValue(opt)"
                />
                <span class="grey-text text-darken-3">{{ !imageStyle ? opt.text : "" }}</span>
                <!-- <div class="opt-text">{{}}</div> -->
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import ExpandTray from "../../addons/ExpandTray";
export default {
  name: "CustomGroupRadioField",
  components: {
    ExpandTray,
  },
  props: {
    helperVideo:{
      type: [Object, Boolean],
      default: false
    },
    cardDefaults: {
      type: String,
      default: 'transparent z-depth-0'
    },
    dataAdditionalValue: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default:'',
    },
    showQuestionNum: {
      type: [Boolean],
      default: true,
    },
    viewConditions:{
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true,
    },
    imageStyle: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      required: false,
    },
    guideButtonText: {
      type: String,
      default: () => "",
    },
    description: {
      default: String,
      default: () => "",
    },
    guideButtonStyle: {
      type: Object,
      default: () => ({}),
    },
    expandList: {
      type: Array,
      default: null,
    },
    titleText: {
      type: String,
      default: () => "",
    },
    questionNum: {
      type: Number,
      default: () => null,
    },
    gridStyle: {
      type: [Object],
      default: () => ({}),
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cardStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    error: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {
      fieldValue: this.value,
      showList: false,
    };
  },
  mounted() {
    // this.$_setValue();
  },
  computed: {
    optOne() {
      return this.options[0];
    },
    optTwo() {
      return this.options[1];
    },
  },
  methods: {
    $_setValue() {
      const ObjLen = Object.keys(this.value).length;
      if (ObjLen <= 0) {
        this.fieldValue = this.optOne;
      }
    },
    $_setSelected(item) {
      if (this.fieldValue.value === item.value) return;
      this.fieldValue = item;
      this.$_updateValue();
    },
    // $_updateValue() {
    //   // console.log(error, hasError);
    //   this.$emit("update", this.fieldValue);
    // },
    $_getImg(pic) {
      if (pic) {
        return require("@/assets/" + pic);
      }
    },
    $_updateValue(opt) {
      if (this.isDisabled) return 
      if(this.viewConditions) {
        if (opt) {
          this.fieldValue = opt.value;
          this.$emit("update", this.fieldValue);
       }
      }
      
    },
    $_getGrid() {
      if (!this.gridStyle.grid) {
        // return this.options.length > 4 ? "col s3" : "col s6";
        return "col s6";
      } else {
        return this.gridStyle.grid;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.c-radio-group-field {
  .card {
    .card-content {
      .card-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .btn-guide-wrapper {
        margin: 2rem 0 0 0;
        display: flex;
        justify-content: center;
        .btn-guide {
          padding: 0 2rem;
        }
      }
    }
  }

/*   .label-text {
    color: #707070;
    font-size: 18px;
  } */

  .btn-container {
    margin: 1rem 0;
  }
}
/* .checked-true {
    .card {
      &::before {
      content: 'check';
      border: 2px solid #5374f8;
      color: #5374f8;
      font-family: 'Material Icons';
      text-align: center;
      font-size: 20px;
      line-height: 24px;
      }
      &::after{
        border-left: 2px solid #5374f8;
      }
    }
  } */
.card {
/*   &::before {
    content: '';
    width: 28px;
    height: 28px;
    position: absolute;
    left: -10px;
    border: 2px solid #dadada;
    border-radius: 50%;
    background: #faf9fa;
    z-index: 8;
    text-align: center;
    font-size: 28px;
    line-height: 24px;
    color: #dadada;
  }
  &::after {
    content: ' ';
    left: 3px;
    top: 0;
    height: 100%;
    width: 2px;
    position: absolute;
    border-left: 2px dashed #dadada;
  } */
  .card-content {
    padding: 16px;
    display: flow-root;
    position: relative;
  }
  
}
.label-text {
  margin-bottom: 12px;
  display: flex;
  .question-number {
    font-size: 18px;
    line-height: 24px;
    margin-right: 6px;
  }
  .question-text {
    font-size: 17px;
    line-height: 22px;
  }
} 
.radio-option {
  margin-bottom: 12px;
    &.card-style {
        border-radius: 5px;
        background: white;
        position: relative;
        padding: 16px;
        border: 1px solid rgba(255, 255, 255, 0);
        &.disabled {
          opacity: 0.75;
        }
    }
    &.active {
      border: 1px solid rgba(83, 116, 248, 0.6);
    }
}
.negative-margins {
  margin: -24px -24px 0;
  display: flow-root;
  padding: 14px;
  @media screen and (min-width: 1024px) {
    margin: 24px 0px 24px;
    width: 100%;
    border-radius: 8px;
  }
}
.negative-margins-no-top {
  margin: 0px -24px 0;
  display: flow-root;
  padding: 14px;
   @media screen and (min-width: 1024px) {
    margin: 0 0 16px 0;
    width: 100%;
    border-radius: 8px;
  }
}

.negative-margins-no-top-no-bottom {
  margin: 0px -24px 0;
  display: flow-root;
  padding: 14px;
   @media screen and (min-width: 1024px) {
    margin: 0 0 0px 0;
    width: 100%;
    border-radius: 8px;
  }
}
span:not(.lever) {
/*     line-height: 20px !important; */
    font-size: 15px !important;
    transform: translateY(-2px) !important;
}
.descriptive-text {
  padding: 0 0px 16px;
}
</style>
